import script from "./PlanCoursewareCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlanCoursewareCard.vue?vue&type=script&lang=ts&setup=true"

import "./PlanCoursewareCard.vue?vue&type=style&index=0&id=612aa2eb&scoped=true&lang=css"
import "./PlanCoursewareCard.vue?vue&type=style&index=1&id=612aa2eb&lang=less&scoped=true"
script.__scopeId = "data-v-612aa2eb"

export default script